module.exports = __webpack_public_path__ + "static/media/xlsx.327c7ded.png";